import React, { useEffect, useState } from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import { FaFileUpload } from "react-icons/fa";
import StoreProfileForm from "./StoreProfileForm";
import FinallReview from "./FinallReview";
import SellerInfo from "./SellerInfo";
import VerifyInfo from "./VerifyInfo";
import { useForm } from "react-hook-form";
import useApi, { getcountry } from "../../hook/useapi";
import axios from "axios";
import { useCountries } from "use-react-countries";
import CurrencyList from "currency-list";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Loading from "../common/Loading";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const SellerInformation = () => {
  const [tabs, setTabs] = useState(1);
  const [categoryInput, setCategoryInput] = useState("");
  const [categories, setCategories] = useState([]);
  const { fetchData } = useApi();
  const { countries } = useCountries();
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
  // console.log(user);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setValue("email", user.email);
    setValue("mobile_number", user.mobile_number);
  }, [setValue]);

  // ✅ Get all currency codes using CurrencyList
  const currencyData = CurrencyList.getAll(); // Returns an object
  const currencydatalist = currencyData.en_IN;

  const tabslist = [
    {
      id: 1,
      name: "Seller Information",
    },
    {
      id: 2,
      name: "Verify Your Identity",
    },
    {
      id: 3,
      name: "Set Up Your Store",
    },
    {
      id: 4,
      name: "Final Review",
    },
  ];

  const navigate = useNavigate(); // Navigation hook

  const [counterdata, setCountryData] = useState([]);
  const countrydata = async () => {
    try {
      const resp = await getcountry();
      // console.log(resp);
      setCountryData(resp.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    countrydata();
  }, []);

  const uploadFiles = async (uploadedMedia) => {
    if (uploadedMedia.length === 0)
      throw new Error("No files selected for upload");

    const fileData = uploadedMedia.map((media) => ({
      fileName: media.name,
      fileType: media.type,
    }));

    try {
      // Generate presigned URLs
      const response = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        { files: fileData },
        { headers: { token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") } }
      );

      if (!response.data.success) {
        throw new Error("Failed to generate pre-signed URLs");
      }

      const preSignedUrls = response.data.directory;

      // Upload files to S3
      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          await axios.put(item.presignedUrl, uploadedMedia[index], {
            headers: {
              "Content-Type": uploadedMedia[index].type,
              "Content-Encoding": "binary",
            },
          });
          console.log(`${item.fileName} uploaded successfully`);
        })
      );

      // Return uploaded file URLs
      return preSignedUrls.map((item) => ({
        media_type: item.fileType.startsWith("image") ? "image" : "pdf",
        url: item.fileUrl,
      }));
    } catch (error) {
      console.error("Upload error:", error);
      throw new Error("Failed to upload files. Please try again.");
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      // Upload Cover Image
      let coverImage = null;
      if (data.cover_image && data.cover_image instanceof File) {
        const uploaded = await uploadFiles([data.cover_image]);
        coverImage = {
          url: uploaded[0].url,
          media_type: data.cover_image.type,
        };
      }

      // Upload Profile Image
      let profileImage = null;
      if (data.profile_image && data.profile_image instanceof File) {
        const uploaded = await uploadFiles([data.profile_image]);
        profileImage = {
          url: uploaded[0].url,
          media_type: data.profile_image.type,
        };
      }

      // Upload Government ID PDF
      let govtId = null;
      if (data.govt_id && data.govt_id instanceof File) {
        const uploaded = await uploadFiles([data.govt_id]);
        govtId = {
          url: uploaded[0].url,
          media_type: data.govt_id.type,
        };
      }

      // Upload Business Certificate PDF
      let businessCertificate = null;
      if (
        data.business_certificate &&
        data.business_certificate instanceof File
      ) {
        const uploaded = await uploadFiles([data.business_certificate]);
        businessCertificate = {
          url: uploaded[0].url,
          media_type: data.business_certificate.type,
        };
      }

      // Upload Passbook / Cancelled Cheque
      let passbook = null;
      if (
        data.passbook_cancelled_cheque &&
        data.passbook_cancelled_cheque instanceof File
      ) {
        const uploaded = await uploadFiles([data.passbook_cancelled_cheque]);
        passbook = {
          url: uploaded[0].url,
          media_type: data.passbook_cancelled_cheque.type,
        };
      }

      // Prepare JSON body with all fields
      const body = {
        name: data.name,
        email: data.email || user.email,
        mobile_number: data.mobile_number || user.mobile_number,
        website: data.website,
        location: data.location,
        country: data.country.toUpperCase(),
        currency: data.currency,
        seller_type: data.Seller_type,
        govt_id: govtId,
        business_certificate: businessCertificate,
        bank_name: data.bank_name,
        account_holder_name: data.account_holder_name,
        account_number: data.account_number,
        routing_number: data.routing_number,
        account_holder_type: data.account_holder_type,
        passbook_cancelled_cheque: passbook,
        store_name: data.store_name,
        store_description: data.store_description,
        categories: data.categories,
        cover_image: coverImage,
        profile_image: profileImage,
      };

      // Send final API request with JSON body
      const resp = await axios.post(
        `${API_BASE_URL}/seller/create-seller-profile/`,
        body,
        {
          headers: {
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Profile created successfully:", resp);
      toast.success("Profile created successfully!");
      navigate("/sellProfile");
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
      toast.error(error?.response?.data?.message || "Submission failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <Leftsidebar />
      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8">
        <LeftResponsivesidebar />
        <Headmenu />
        <main className="flex min-w-0">
          <div className="min-w-0 w-full">
            <div className="flex flex-col sm:flex-row space-y-5 sm:space-y-0 justify-between sm:items-center py-2">
              <div>
                <p className="text-xl">Start Your Seller Journey</p>
              </div>
              {/* <div>
                <button className="px-8 py-2 border-2 border-[#095228] rounded-[20px]">
                  Save as Draft
                </button>
              </div> */}
            </div>
            {/* <div className="flex flex-wrap gap-10 sm:gap-20 mt-5">
              {tabslist.map((i, id) => (
                <button
                  key={id}
                  className={`font-[600] ${
                    i.id === tabs ? "text-[#095228]" : "text-gray-500"
                  }`}
                  onClick={() => setTabs(i.id)}
                >
                  {i.name}
                </button>
              ))}
            </div> */}

            <div className="flex gap-6 md:gap-10 lg:flex-wrap lg:gap-20 mt-5 mb-4 overflow-x-auto pb-1">
              {tabslist.map((i, id) => (
                <button
                  key={id}
                  type="button"
                  disabled={i.id > tabs} // ❌ disable future tabs
                  className={`font-[600] shrink-0 whitespace-nowrap ${
                    i.id === tabs ? "text-[#095228]" : "text-gray-500"
                  } ${i.id > tabs ? "cursor-not-allowed opacity-50" : ""}`} // style disabled
                  onClick={() => {
                    if (i.id <= tabs) setTabs(i.id); // ✅ only allow going back
                  }}
                >
                  {i.name}
                </button>
              ))}
            </div>

            {loading === true ? (
              <div className="flex justify-center mt-28">
                <Loading />
              </div>
            ) : (
              <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
                {tabs === 1 ? (
                  <div>
                    <SellerInfo
                      register={register}
                      handleSubmit={handleSubmit}
                      errors={errors}
                      watch={watch}
                      onSubmit={onSubmit}
                      setTabs={setTabs}
                      setValue={setValue}
                      countries={countries}
                      currencydatalist={currencydatalist}
                      counterdata={counterdata}
                    />
                  </div>
                ) : tabs === 2 ? (
                  <div>
                    <VerifyInfo
                      register={register}
                      handleSubmit={handleSubmit}
                      errors={errors}
                      watch={watch}
                      onSubmit={onSubmit}
                      setTabs={setTabs}
                      setValue={setValue}
                    />
                  </div>
                ) : tabs === 3 ? (
                  <div className="">
                    <StoreProfileForm
                      register={register}
                      handleSubmit={handleSubmit}
                      errors={errors}
                      watch={watch}
                      onSubmit={onSubmit}
                      setTabs={setTabs}
                      setValue={setValue}
                      categories={categories}
                      setCategories={setCategories}
                    />
                  </div>
                ) : (
                  tabs === 4 && (
                    <div>
                      <FinallReview
                        register={register}
                        handleSubmit={handleSubmit}
                        errors={errors}
                        watch={watch}
                        onSubmit={onSubmit}
                        setTabs={setTabs}
                        setValue={setValue}
                        categories={categories}
                      />
                    </div>
                  )
                )}
              </form>
            )}
          </div>
        </main>
      </main>
    </div>
  );
};

export default SellerInformation;
